/**
 * DocumentsTab — Email attachments for the affaire
 * Reuses the tracker's TrackerAttachmentsTab component
 */

import React from 'react';
import { TrackerAttachmentsTab } from '@/features/admin/tabs/tracker/components/TrackerAttachmentsTab';
import { useTrackerEmails } from '@/features/admin/tabs/tracker/hooks/useTrackerEmails';

interface DocumentsTabProps {
  affaireId: number;
}

export const DocumentsTab: React.FC<DocumentsTabProps> = ({ affaireId }) => {
  const { data: emailsResponse, isLoading } = useTrackerEmails(affaireId);
  const emails = emailsResponse?.data || [];

  return (
    <TrackerAttachmentsTab
      emails={emails}
      isLoading={isLoading}
    />
  );
};
